module.exports = __webpack_public_path__ + "img/2.08f92784.png";